<template>
  <div class="content">
    <navigation :navName="nav"></navigation>
    <template>
      <el-form ref="editForm"
               :model="editForm"
               class="mobile-show-box form-wrapper"
               :label-width="formLabelWidth"
               :rules='formRule'>
        <el-form-item prop='title'
                      label="标题">
          <el-input placeholder="请输入标题"
                    v-model="editForm.title"
                    size="mini"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="main_img"
                      label="Banner">
          <div class="single-img-upload">
            <el-upload :action="imgUpload"
                       :class="{disabled:uploadDisabledImage}"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-success="handlePictureSuccess"
                       :on-remove="handleRemoveImage"
                       :before-upload="beforeAvatarUpload"
                       :file-list="imgList"
                       :headers="isOverSea">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisibleImage">
              <img width="100%"
                   :src="dialogImageUrl"
                   alt="" />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="视频上传">
          <el-upload :action="imgUpload"
                     :class="{disabled:uploadDisabledFile}"
                     :on-success="handleFileSuccess"
                     :on-remove="handleRemoveFile"
                     :before-upload="beforeUploadFile"
                     :file-list="fileList"
                     multiple
                     :limit="1"
                     :headers="isOverSea">
            <el-button size="small"
                       type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="优先级排序">
          <el-input type="number"
                    min="0"
                    size="mini"
                    v-model="editForm.sort"
                    class="num-input">
          </el-input>
          <span class="warning-span">注：数字越小优先级越高</span>
        </el-form-item>
        <el-form-item label="是否发布">
          <el-radio v-model="editForm.release"
                    label="true">发布</el-radio>
          <el-radio v-model="editForm.release"
                    label="false">不发布</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button size="mini"
                     type="primary"
                     @click="addArt()">提交</el-button>
          <el-button size="mini"
                     @click="back()">取消</el-button>
        </el-form-item>
      </el-form>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import api from '../../api/api';
import navigation from './navigation';

export default {
  data() {
    return {
      editForm: {
        img: '',
        video: '',
        release: 'false',
        sort: 0,
        title: '',
      },
      dialogImageUrl: '',
      dialogVisibleImage: false,
      dialogVisibleFile: false,
      imgUpload: `${api.url}upload`,
      uploadDisabledImage: false,
      uploadDisabledFile: false,
      imgList: [],
      fileList: [],
      formRule: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        main_img: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      id: '',
      bannerList: [],
      bannerId: '',
      nav: '',
      formLabelWidth: '90px',
    };
  },
  created() {
    if (this.$store.state.bannerId) {
      this.id = this.$store.state.bannerId;
      axios.post(`${api.url}bannerDetail`, { id: this.$store.state.bannerId }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          const content = data.content;
          this.editForm = content;

          this.editForm.release = `${content.release}`;
          if (content.img) {
            if (content.img) {
              this.uploadDisabledImage = true;
              this.editForm.img = content.img;
              this.imgList = [{ url: this.$store.state.publicUrl + content.img, status: 'finished' }];
            }
          }
          if (content.video) {
            this.editForm.video = content.video;
            this.fileList = [{ url: this.$store.state.publicUrl + content.video, name: this.$store.state.publicUrl + content.video, status: 'finished' }];
          }
        }
      });
    }
  },
  components: {
    navigation,
  },
  methods: {
    back() {
      this.$router.back(-1);
    },
    // 修改设置
    addArt() {
      if (this.editForm.title === '') {
        this.$message({
          message: '请填写标题',
          type: 'warning',
        });
        return;
      }
      if (this.editForm.img === '') {
        this.$message({
          message: '请上传图片',
          type: 'warning',
        });
        return;
      }
      const data = Object.assign(this.editForm, {
        wid: this.$store.state.websiteId,
        id: this.id,
        type: this.$store.state.navName,
      });
      axios.post(`${api.url}addBanner`, data).then((response) => {
        if (response.data.ret === 0) {
          this.$alert(response.data.msg, '', {
            confirmButtonText: '确定',
            callback: () => {
              const bannerData = {
                type: this.$store.state.navName,
                wid: this.$store.state.websiteId,
              };
              this.$store.dispatch('getBannerList', bannerData);
              window.history.back();
            },
          });
        }
      });
    },
    handleRemoveImage() {
      this.uploadDisabledImage = false;
      this.editForm.img = '';
    },
    handleRemoveFile() {
      this.editForm.video = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImage = true;
    },
    handlePictureSuccess(file) {
      if (file.ret === 0) {
        this.uploadDisabledImage = true;
        this.editForm.img = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    handleFileSuccess(file) {
      if (file.ret === 0) {
        this.editForm.video = file.url;
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isGif = file.type === 'image/gif';
      if (!isJPG && !isPng && !isGif) {
        this.$message.error('上传图片只能是 JPG 格式,GIF格式 或者 PNG 格式!');
      }
    },
    beforeUploadFile(file) {
      const extension = file.type === 'video/mp4';
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!extension) {
        this.$message.error('上传视频只支持mp4格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频大小不超过30M!');
      }
    },
  },
  computed: {
    isOverSea() {
      const object = {};
      object.isOverSea = this.$store.state.is_overSea;
      return object;
    },
  },
};
</script>
<style lang="less">
.content {
  margin: 0 auto;
  .el-row {
    margin-top: 10px;
    line-height: 40px;
  }
  .el-col-4 {
    text-align: right;
  }
  .el-col-20 {
    padding-left: 20px;
    text-align: left;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    overflow: auto;
    height: 500px;
  }
  .quill-editor {
    line-height: 1;
  }
  .sumbit-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}

.disabled .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/websiteConfig/editBanner.vue